import { render } from "./CourseCard.vue?vue&type=template&id=d0aff49c&scoped=true&ts=true"
import script from "./CourseCard.vue?vue&type=script&lang=ts"
export * from "./CourseCard.vue?vue&type=script&lang=ts"

import "./CourseCard.vue?vue&type=style&index=0&id=d0aff49c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0aff49c"],['__file',"src/components/courses/CourseCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d0aff49c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d0aff49c', __exports__)) {
    api.reload('d0aff49c', __exports__)
  }
  
  module.hot.accept("./CourseCard.vue?vue&type=template&id=d0aff49c&scoped=true&ts=true", () => {
    api.rerender('d0aff49c', render)
  })

}


export default __exports__